// A new trial-flavoured plan has to be added to TRIAL_PLAN_TYPES as well as PLAN_TYPES,
// or PostRules stops offering the trial-window input for it.

export const PLAN_TYPE = Object.freeze({
  FREE: "FREE",
  TRIAL: "TRIAL",
  TRIAL_STARTER: "TRIAL_STARTER",
  TRIAL_PRIME: "TRIAL_PRIME",
  TRIAL_PREMIER: "TRIAL_PREMIER",
  ACTIVE_SUBSCRIBERS: "ACTIVE_SUBSCRIBERS",
  ACTIVE_STARTER: "ACTIVE_STARTER",
  ACTIVE_PRIME: "ACTIVE_PRIME",
  ACTIVE_PREMIER: "ACTIVE_PREMIER",
})

export const PLAN_TYPES = [
  { value: PLAN_TYPE.FREE, labelKey: "plans.types.free" },
  { value: PLAN_TYPE.TRIAL, labelKey: "plans.types.trial" },
  { value: PLAN_TYPE.TRIAL_STARTER, labelKey: "plans.types.trial_starter" },
  { value: PLAN_TYPE.TRIAL_PRIME, labelKey: "plans.types.trial_prime" },
  { value: PLAN_TYPE.TRIAL_PREMIER, labelKey: "plans.types.trial_premier" },
  { value: PLAN_TYPE.ACTIVE_SUBSCRIBERS, labelKey: "plans.types.active_subscribers" },
  { value: PLAN_TYPE.ACTIVE_STARTER, labelKey: "plans.types.active_starter" },
  { value: PLAN_TYPE.ACTIVE_PRIME, labelKey: "plans.types.active_prime" },
  { value: PLAN_TYPE.ACTIVE_PREMIER, labelKey: "plans.types.active_premier" },
]

export const TRIAL_PLAN_TYPES = [
  PLAN_TYPE.TRIAL,
  PLAN_TYPE.TRIAL_STARTER,
  PLAN_TYPE.TRIAL_PRIME,
  PLAN_TYPE.TRIAL_PREMIER,
]
